function DashboardActiveMainLaps({value}) {
    const sessionIcon = {
        0: "mode_off_on",
        1: "replay",
        2: "check_circle",
        3: "pause_circle",
    }[value["session-status"]] || "mode_off_on";

    const sessionIconColor = {
        0: "material-symbols-outlined text-acc-red",
        1: "material-symbols-outlined text-acc-blue",
        2: "material-symbols-outlined text-acc-green",
        3: "material-symbols-outlined text-acc-yellow",
    }[value["session-status"]] || "material-symbols-outlined text-acc-red";

    return (
        <div className="flex flex-col gap-1">
            <h2 className="text-xs font-bold uppercase text-[#92adc9] tracking-wider">Race Standings</h2>
            <div className="flex items-baseline justify-between">
                <p className="text-2xl font-bold">P{value.position} <span className="text-sm font-normal text-[#92adc9]">/ {value["active-cars"]}</span></p>
                <span className={sessionIconColor}>{sessionIcon}</span>
            </div>
        </div>
    );
}

export default DashboardActiveMainLaps;